import { apiClient } from 'services/api-client';
import { apiConfig } from 'config/app.config';
import { getCurrentAccessToken } from 'services/auth/supabase.client';
import { DataHealth, PriceChange } from 'dtos/data/data-health.dto';

export const StoreDataService = {
  health: async (orgId: string, storeId: string) =>
    (await apiClient.get<DataHealth>(`/orgs/${orgId}/stores/${storeId}/data-health`)).data,

  priceChanges: async (orgId: string, storeId: string) =>
    (await apiClient.get<PriceChange[]>(`/orgs/${orgId}/stores/${storeId}/price-changes`)).data,

  downloadPriceChanges: async (orgId: string, storeId: string) => {
    const token = await getCurrentAccessToken();
    const response = await fetch(`${apiConfig.baseUrl}/alerts/orgs/${orgId}/stores/${storeId}/price-changes?format=csv`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (!response.ok) throw new Error('The price-change sheet could not be downloaded. Please try again.');
    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = url;
    link.download = `price-changes-${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  },
};
